var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myReview" },
    [
      _c(
        "el-tabs",
        {
          attrs: { value: _vm.tabActiveName },
          on: { "tab-click": _vm.handleTabClick },
        },
        [
          _vm.$hasBtnRoles("/user/project-delivery/my-audit-project")
            ? _c("el-tab-pane", { attrs: { label: "项目列表", name: "1" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.reviewProjectCount,
                          max: 99,
                          hidden: _vm.reviewProjectCount === 0,
                        },
                      },
                      [_vm._v(" 项目列表 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.$hasBtnRoles("/user/project-delivery/my-audit-mall")
            ? _c("el-tab-pane", { attrs: { label: "商城装修", name: "2" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.reviewMallCount,
                          max: 99,
                          hidden: _vm.reviewMallCount === 0,
                        },
                      },
                      [_vm._v(" 商城装修 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.$hasBtnRoles("/user/project-delivery/my-audit-printing")
            ? _c(
                "el-tab-pane",
                { attrs: { label: "定制设计及印刷", name: "4" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c(
                        "el-badge",
                        {
                          attrs: {
                            value: _vm.reviewPrintingCount,
                            max: 99,
                            hidden: _vm.reviewPrintingCount === 0,
                          },
                        },
                        [_vm._v(" 定制设计及印刷 ")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm.$hasBtnRoles("/user/project-ticket/my-audit")
            ? _c("el-tab-pane", { attrs: { label: "咨询工单", name: "5" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.reviewTicketCount,
                          max: 99,
                          hidden: _vm.reviewTicketCount === 0,
                        },
                      },
                      [_vm._v(" 咨询工单 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.$hasBtnRoles("/user/project-delivery/my-audit-quotation")
            ? _c("el-tab-pane", { attrs: { label: "报价单审核", name: "6" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.reviewQuotationCount,
                          max: 99,
                          hidden: _vm.reviewQuotationCount === 0,
                        },
                      },
                      [_vm._v(" 报价单审核 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.$hasBtnRoles("/user/project-delivery/my-audit-quotation-bind")
            ? _c("el-tab-pane", { attrs: { label: "报价单分发", name: "7" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.reviewQuotationBindCount,
                          max: 99,
                          hidden: _vm.reviewQuotationBindCount === 0,
                        },
                      },
                      [_vm._v(" 报价单分发 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !["5", "6", "7"].includes(_vm.tabActiveName),
              expression: "!['5', '6', '7'].includes(tabActiveName)",
            },
          ],
          ref: "searchForm",
          attrs: { id: "searchDom", inline: "" },
        },
        [
          _c(
            "el-form-item",
            { key: "f1", attrs: { label: "项目ID" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入项目ID" },
                model: {
                  value: _vm.searchForm.number,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "number", $$v)
                  },
                  expression: "searchForm.number",
                },
              }),
            ],
            1
          ),
          _vm.tabActiveName != "1"
            ? _c(
                "el-form-item",
                { key: "f2", attrs: { label: "任务ID" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入任务ID" },
                    model: {
                      value: _vm.searchForm.item_number,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "item_number", $$v)
                      },
                      expression: "searchForm.item_number",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { key: "f3", attrs: { label: "客户名称" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    remote: "",
                    "remote-method": _vm.getCompanyList,
                    clearable: "",
                    filterable: "",
                    placeholder: "请输入公司名称",
                  },
                  model: {
                    value: _vm.searchForm.customer_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "customer_id", $$v)
                    },
                    expression: "searchForm.customer_id",
                  },
                },
                _vm._l(_vm.companyList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.company_name + "（" + item.id + "）",
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { key: "f4", attrs: { label: "项目名称" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入项目名称" },
                model: {
                  value: _vm.searchForm.project_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "project_name", $$v)
                  },
                  expression: "searchForm.project_name",
                },
              }),
            ],
            1
          ),
          _vm.tabActiveName == "1"
            ? _c(
                "el-form-item",
                { key: "f5", attrs: { label: "项目类型" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "230px" },
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.searchForm.project_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "project_type", $$v)
                        },
                        expression: "searchForm.project_type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "个性化项目评估（启动会）", value: 1 },
                      }),
                      _c("el-option", {
                        attrs: { label: "其他个性化需求", value: 2 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "1"
            ? _c(
                "el-form-item",
                { key: "f6", attrs: { label: "任务" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.searchForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "type", $$v)
                        },
                        expression: "searchForm.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "商城装修", value: 1 },
                      }),
                      _c("el-option", {
                        attrs: { label: "投标支持", value: 2 },
                      }),
                      _c("el-option", {
                        attrs: { label: "定制设计印刷", value: 3 },
                      }),
                      _c("el-option", { attrs: { label: "报价单", value: 9 } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f7", attrs: { label: "加急设计" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.expedited_not,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "expedited_not", $$v)
                        },
                        expression: "searchForm.expedited_not",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "需要", value: 2 } }),
                      _c("el-option", { attrs: { label: "不需要", value: 1 } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.tabActiveName == "4"
            ? _c(
                "el-form-item",
                { key: "f8", attrs: { label: "加急印刷" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.urgent_printing,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "urgent_printing", $$v)
                        },
                        expression: "searchForm.urgent_printing",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "需要", value: 2 } }),
                      _c("el-option", { attrs: { label: "不需要", value: 1 } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { key: "f9", attrs: { label: "提交人" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    remote: "",
                    "remote-method": _vm.searchSubmitter,
                    loading: _vm.personLoading,
                    "no-data-text": "无数据",
                    placeholder: "请选择",
                  },
                  on: {
                    clear: function ($event) {
                      return _vm.searchSubmitter("")
                    },
                  },
                  model: {
                    value: _vm.searchForm.user_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "user_id", $$v)
                    },
                    expression: "searchForm.user_id",
                  },
                },
                _vm._l(_vm.personOptions.submitter || [], function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label:
                        item.name +
                        (item.status_cn && item.status_cn !== "在职"
                          ? "（" + item.status_cn + "）"
                          : ""),
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { key: "f10" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.resetList },
                },
                [_vm._v("搜 索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabActiveName == "5",
              expression: "tabActiveName == '5'",
            },
          ],
          ref: "ticketSearchForm",
          attrs: { id: "ticketSearchDom", inline: "" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "工单编号" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入工单编号" },
                model: {
                  value: _vm.ticketSearchForm.work_order_no,
                  callback: function ($$v) {
                    _vm.$set(_vm.ticketSearchForm, "work_order_no", $$v)
                  },
                  expression: "ticketSearchForm.work_order_no",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "工单标题" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入工单标题" },
                model: {
                  value: _vm.ticketSearchForm.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.ticketSearchForm, "title", $$v)
                  },
                  expression: "ticketSearchForm.title",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "咨询事项" } },
            [
              _c("el-cascader", {
                staticStyle: { width: "230px" },
                attrs: {
                  options: _vm.ticketCategoryTree,
                  props: {
                    multiple: true,
                    label: "name",
                    value: "id",
                    children: "children",
                  },
                  "collapse-tags": "",
                  clearable: "",
                  filterable: "",
                  placeholder: "请选择",
                },
                model: {
                  value: _vm.ticketSearchForm.second_category_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.ticketSearchForm, "second_category_id", $$v)
                  },
                  expression: "ticketSearchForm.second_category_id",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "具体事项" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入具体事项" },
                model: {
                  value: _vm.ticketSearchForm.item,
                  callback: function ($$v) {
                    _vm.$set(_vm.ticketSearchForm, "item", $$v)
                  },
                  expression: "ticketSearchForm.item",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "提交时间" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "230px" },
                attrs: {
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "value-format": "yyyy-MM-dd",
                  format: "yyyy-MM-dd",
                },
                on: { change: _vm.changeTicketCreatedAtTime },
                model: {
                  value: _vm.ticketCreatedAtTime,
                  callback: function ($$v) {
                    _vm.ticketCreatedAtTime = $$v
                  },
                  expression: "ticketCreatedAtTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.ticketResetList },
                },
                [_vm._v("搜 索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !["5", "6", "7"].includes(_vm.tabActiveName),
              expression: "!['5', '6', '7'].includes(tabActiveName)",
            },
          ],
          attrs: {
            border: "",
            "header-cell-style": { background: "#f1f1f1", color: "#333333" },
            align: "center",
            data: _vm.listData,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label:
                _vm.tabActiveName == "1"
                  ? "项目ID/项目状态"
                  : "任务ID/项目状态",
              width: "140",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.number))]),
                    _c("div", [_vm._v(_vm._s(scope.row.status_cn))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "客户名称/项目名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.customer_name) +
                          "(" +
                          _vm._s(scope.row.customer_id) +
                          ")"
                      ),
                    ]),
                    _c("div", [_vm._v(_vm._s(scope.row.project_name))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "项目类型/任务", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.project_type_cn))]),
                    _vm._l(scope.row.type_of_demand, function (value, index) {
                      return _c("div", { key: index }, [
                        _c("span", [_vm._v(_vm._s(value.type_cn))]),
                        _vm._v(" （ "),
                        _c(
                          "span",
                          {
                            style: {
                              color:
                                {
                                  1: "#409EFF",
                                  50: "#E6A23C",
                                  100: "#F56C6C",
                                  200: "#409EFF",
                                  201: "#409EFF",
                                  300: "#909399",
                                  400: "#F56C6C",
                                  800: "#909399",
                                }[value.status] || "#409EFF",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                {
                                  1: "待审批",
                                  50: "待分配",
                                  100: "处理中",
                                  200: "待验收",
                                  201: "设计完成待确认",
                                  300: "已完成",
                                  400: "审批驳回",
                                  450: "已开标未出结果",
                                  500: "未中标",
                                  550: "中标未交付",
                                  600: "中标已交付",
                                  800: "已失效",
                                }[value.status]
                              )
                            ),
                          ]
                        ),
                        _vm._v(" ） "),
                      ])
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm.tabActiveName == "4"
            ? _c("el-table-column", {
                attrs: { label: "印刷单", width: "90" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return _vm._l(
                          _vm.getPrintingSheetValues(scope.row),
                          function (value) {
                            return _c("div", { key: value }, [
                              _vm._v(" " + _vm._s(value) + " "),
                            ])
                          }
                        )
                      },
                    },
                  ],
                  null,
                  false,
                  4287540148
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "负责人/审批人", prop: "head", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._l(scope.row.head, function (value, index) {
                      return _c("div", { key: index }, [
                        _vm._v(" " + _vm._s(value) + " "),
                      ])
                    }),
                    _vm._l(scope.row.approver, function (item, index) {
                      return _c("div", { key: "approver" + index }, [
                        _vm._v(" " + _vm._s(_vm.formatApprover(item)) + " "),
                      ])
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "提交人/提交时间", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.create_name))]),
                    _c("div", [_vm._v(_vm._s(scope.row.user_organize_name))]),
                    _c("div", [_vm._v(_vm._s(scope.row.created_at))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "处理人/处理时间", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.tabActiveName != "1"
                      ? [
                          _c("div", [
                            _vm._v(_vm._s(scope.row.task_handler_name)),
                          ]),
                          _c("div", [
                            _vm._v(_vm._s(scope.row.task_handler_time)),
                          ]),
                        ]
                      : [
                          _c("div", [_vm._v(_vm._s(scope.row.handler_name))]),
                          scope.row.create_name
                            ? _c("div", [_vm._v(_vm._s(scope.row.updated_at))])
                            : _vm._e(),
                        ],
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "跟进记录", prop: "operation" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operation && scope.row.operation.length > 9
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "tipBox",
                            attrs: {
                              "popper-class": "popperTipBox",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              _vm._l(
                                scope.row.operation,
                                function (value, index) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(value.created_at) +
                                        " " +
                                        _vm._s(value.operation_id) +
                                        " " +
                                        _vm._s(value.content) +
                                        " "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                            _vm._l(
                              scope.row.operation,
                              function (value, index) {
                                return _c("div", { key: index }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(value.created_at) +
                                      " " +
                                      _vm._s(value.operation_id) +
                                      " " +
                                      _vm._s(value.content) +
                                      " "
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        )
                      : _c(
                          "div",
                          _vm._l(scope.row.operation, function (value, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                " " +
                                  _vm._s(value.created_at) +
                                  " " +
                                  _vm._s(value.operation_id) +
                                  " " +
                                  _vm._s(value.content) +
                                  " "
                              ),
                            ])
                          }),
                          0
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    !(_vm.tabActiveName == "1" && scope.row.project_type == 2)
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.approve(scope.row)
                              },
                            },
                          },
                          [_vm._v("审批")]
                        )
                      : _vm._e(),
                    _vm.$hasBtnRoles("/user/project-delivery/follow-up")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openFollowUp(scope.row)
                              },
                            },
                          },
                          [_vm._v("跟进")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !["5", "6", "7"].includes(_vm.tabActiveName),
              expression: "!['5', '6', '7'].includes(tabActiveName)",
            },
          ],
          staticClass: "pages",
          staticStyle: { "text-align": "right", margin: "16px 0" },
        },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.listPages.currentPage,
              "page-size": _vm.searchForm.pageSize,
              "page-sizes": [20, 50, 100, 200, 500],
              total: _vm.listPages.totalCount,
              layout: "total,sizes, prev, pager, next, jumper",
            },
            on: {
              "current-change": _vm.handlePageChange,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: ["6", "7"].includes(_vm.tabActiveName),
              expression: "['6', '7'].includes(tabActiveName)",
            },
          ],
          ref: "quotationSearchForm",
          attrs: { id: "quotationSearchDom", inline: "" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "项目ID" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入项目ID" },
                model: {
                  value: _vm.quotationSearchForm.number,
                  callback: function ($$v) {
                    _vm.$set(_vm.quotationSearchForm, "number", $$v)
                  },
                  expression: "quotationSearchForm.number",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "客户名称" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    remote: "",
                    "remote-method": _vm.getCompanyList,
                    clearable: "",
                    filterable: "",
                    placeholder: "请输入公司名称",
                  },
                  model: {
                    value: _vm.quotationSearchForm.customer_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.quotationSearchForm, "customer_id", $$v)
                    },
                    expression: "quotationSearchForm.customer_id",
                  },
                },
                _vm._l(_vm.companyList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.company_name + "（" + item.id + "）",
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "项目名称" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入项目名称" },
                model: {
                  value: _vm.quotationSearchForm.project_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.quotationSearchForm, "project_name", $$v)
                  },
                  expression: "quotationSearchForm.project_name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "提交人" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    remote: "",
                    "remote-method": _vm.searchQuotationSubmitter,
                    loading: _vm.personLoading,
                    "no-data-text": "无数据",
                    placeholder: "请选择",
                  },
                  on: {
                    clear: function ($event) {
                      return _vm.searchQuotationSubmitter("")
                    },
                  },
                  model: {
                    value: _vm.quotationSearchForm.user_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.quotationSearchForm, "user_id", $$v)
                    },
                    expression: "quotationSearchForm.user_id",
                  },
                },
                _vm._l(
                  _vm.personOptions.quotationSubmitter || [],
                  function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: {
                        label:
                          item.name +
                          (item.status_cn && item.status_cn !== "在职"
                            ? "（" + item.status_cn + "）"
                            : ""),
                        value: item.id,
                      },
                    })
                  }
                ),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.quotationResetList },
                },
                [_vm._v("搜 索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: ["6", "7"].includes(_vm.tabActiveName),
              expression: "['6', '7'].includes(tabActiveName)",
            },
          ],
          attrs: {
            border: "",
            "header-cell-style": { background: "#f1f1f1", color: "#333333" },
            align: "center",
            data: _vm.quotationListData,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "项目ID/项目状态", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.number))]),
                    _c("div", [_vm._v(_vm._s(scope.row.status_cn))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "客户名称/项目名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.customer_name) +
                          "(" +
                          _vm._s(scope.row.customer_id) +
                          ")"
                      ),
                    ]),
                    _c("div", [_vm._v(_vm._s(scope.row.project_name))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "项目类型/任务", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.project_type_cn))]),
                    _vm._l(scope.row.type_of_demand, function (value, index) {
                      return _c("div", { key: index }, [
                        _c("span", [_vm._v(_vm._s(value.type_cn))]),
                        _vm._v(" （ "),
                        _c(
                          "span",
                          {
                            style: {
                              color:
                                {
                                  1: "#409EFF",
                                  50: "#E6A23C",
                                  100: "#F56C6C",
                                  200: "#409EFF",
                                  201: "#409EFF",
                                  300: "#909399",
                                  400: "#F56C6C",
                                  800: "#909399",
                                }[value.status] || "#409EFF",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                {
                                  1: "待审批",
                                  50: "待分配",
                                  100: "处理中",
                                  200: "待验收",
                                  201: "设计完成待确认",
                                  300: "已完成",
                                  400: "审批驳回",
                                  450: "已开标未出结果",
                                  500: "未中标",
                                  550: "中标未交付",
                                  600: "中标已交付",
                                  800: "已失效",
                                }[value.status]
                              )
                            ),
                          ]
                        ),
                        _vm._v(" ） "),
                      ])
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm.tabActiveName == "6"
            ? _c("el-table-column", {
                attrs: { label: "当前审批节点", width: "130" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.currentApprover(scope.row).approver_name
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatApprover(
                                        _vm.currentApprover(scope.row)
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1888558298
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "提交人/提交时间", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.create_name))]),
                    _c("div", [_vm._v(_vm._s(scope.row.user_organize_name))]),
                    _c("div", [_vm._v(_vm._s(scope.row.created_at))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "处理人/处理时间", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.task_handler_name))]),
                    _c("div", [_vm._v(_vm._s(scope.row.task_handler_time))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "跟进记录", prop: "operation" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operation && scope.row.operation.length > 9
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "tipBox",
                            attrs: {
                              "popper-class": "popperTipBox",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              _vm._l(
                                scope.row.operation,
                                function (value, index) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(value.created_at) +
                                        " " +
                                        _vm._s(value.operation_id) +
                                        " " +
                                        _vm._s(value.content) +
                                        " "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                            _vm._l(
                              scope.row.operation,
                              function (value, index) {
                                return _c("div", { key: index }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(value.created_at) +
                                      " " +
                                      _vm._s(value.operation_id) +
                                      " " +
                                      _vm._s(value.content) +
                                      " "
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        )
                      : _c(
                          "div",
                          _vm._l(scope.row.operation, function (value, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                " " +
                                  _vm._s(value.created_at) +
                                  " " +
                                  _vm._s(value.operation_id) +
                                  " " +
                                  _vm._s(value.content) +
                                  " "
                              ),
                            ])
                          }),
                          0
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _vm.tabActiveName == "6"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.approve(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.approveButtonText(scope.row)))]
                        )
                      : _vm._e(),
                    _vm.tabActiveName == "7"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openQuotationAssign(scope.row)
                              },
                            },
                          },
                          [_vm._v("分配负责人")]
                        )
                      : _vm._e(),
                    _vm.$hasBtnRoles("/user/project-delivery/follow-up")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openFollowUp(scope.row)
                              },
                            },
                          },
                          [_vm._v("跟进")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: ["6", "7"].includes(_vm.tabActiveName),
              expression: "['6', '7'].includes(tabActiveName)",
            },
          ],
          staticClass: "pages",
          staticStyle: { "text-align": "right", margin: "16px 0" },
        },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.quotationListPages.currentPage,
              "page-size": _vm.quotationSearchForm.pageSize,
              "page-sizes": [20, 50, 100, 200, 500],
              total: _vm.quotationListPages.totalCount,
              layout: "total,sizes, prev, pager, next, jumper",
            },
            on: {
              "current-change": _vm.handleQuotationPageChange,
              "size-change": _vm.quotationSizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabActiveName == "5",
              expression: "tabActiveName == '5'",
            },
          ],
          attrs: {
            border: "",
            "header-cell-style": { background: "#f1f1f1", color: "#333333" },
            align: "center",
            data: _vm.ticketListData,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "工单信息", width: "240" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v("ID：" + _vm._s(scope.row.work_order_no)),
                    ]),
                    _c("div", [_vm._v("标题：" + _vm._s(scope.row.title))]),
                    _c("div", [
                      _vm._v("提交时间：" + _vm._s(scope.row.created_at)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "咨询事项" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.category || "-"))]),
                    _c("div", [
                      _vm._v(_vm._s(scope.row.second_category || "-")),
                    ]),
                    _c("div", [_vm._v(_vm._s(scope.row.item || "-"))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "事项描述", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.description
                      ? _c("el-tooltip", { attrs: { placement: "top" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "ticketDescTip",
                              attrs: { slot: "content" },
                              slot: "content",
                            },
                            [_vm._v(" " + _vm._s(scope.row.description) + " ")]
                          ),
                          _c("div", { staticClass: "ticketDescBox" }, [
                            _vm._v(_vm._s(scope.row.description)),
                          ]),
                        ])
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "当前处理人", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          (scope.row.handler_list &&
                            scope.row.handler_list
                              .map(function (item) {
                                return item.handler_name
                              })
                              .join("、")) ||
                            "-"
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "处理结果", width: "90" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          { 10: "待分配", 20: "处理中", 30: "已解决" }[
                            scope.row.status
                          ] || "-"
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "跟进记录" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operation && scope.row.operation.length > 9
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "tipBox",
                            attrs: {
                              "popper-class": "popperTipBox",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              _vm._l(
                                scope.row.operation,
                                function (value, index) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(value.created_at) +
                                        " " +
                                        _vm._s(value.operation_id) +
                                        " " +
                                        _vm._s(value.content) +
                                        " "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                            _vm._l(
                              scope.row.operation,
                              function (value, index) {
                                return _c("div", { key: index }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(value.created_at) +
                                      " " +
                                      _vm._s(value.operation_id) +
                                      " " +
                                      _vm._s(value.content) +
                                      " "
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        )
                      : _c(
                          "div",
                          _vm._l(scope.row.operation, function (value, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                " " +
                                  _vm._s(value.created_at) +
                                  " " +
                                  _vm._s(value.operation_id) +
                                  " " +
                                  _vm._s(value.content) +
                                  " "
                              ),
                            ])
                          }),
                          0
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.viewTicketDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    Number(scope.row.status) === 10
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openAssignDialog(scope.row)
                              },
                            },
                          },
                          [_vm._v("分配负责人")]
                        )
                      : _vm._e(),
                    Number(scope.row.status) === 10
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openTicketFollowUp(scope.row)
                              },
                            },
                          },
                          [_vm._v("跟进")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabActiveName == "5",
              expression: "tabActiveName == '5'",
            },
          ],
          staticClass: "pages",
          staticStyle: { "text-align": "right", margin: "16px 0" },
        },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.ticketListPages.currentPage,
              "page-size": _vm.ticketSearchForm.pageSize,
              "page-sizes": [20, 50, 100, 200, 500],
              total: _vm.ticketListPages.totalCount,
              layout: "total,sizes, prev, pager, next, jumper",
            },
            on: {
              "current-change": _vm.handleTicketPageChange,
              "size-change": _vm.ticketSizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.ticketDrawerVisible,
            "destroy-on-close": true,
            "append-to-body": "",
            "custom-class": "myFormDrawer",
            size: "88%",
            title: "工单详情",
          },
          on: {
            "update:visible": function ($event) {
              _vm.ticketDrawerVisible = $event
            },
          },
        },
        [
          _c("ticketForm", {
            attrs: {
              visible: _vm.ticketDrawerVisible,
              id: _vm.ticketFormId,
              type: _vm.ticketFormType,
              customerName: _vm.ticketFormCustomerName,
            },
            on: {
              "update:visible": function ($event) {
                _vm.ticketDrawerVisible = $event
              },
              success: _vm.handleTicketFormSuccess,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.applyFormVisible,
            "destroy-on-close": true,
            "append-to-body": "",
            "custom-class": "myFormDrawer",
            size: "88%",
            title: _vm.drawerTitle,
          },
          on: {
            "update:visible": function ($event) {
              _vm.applyFormVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c("applyForm", {
            attrs: {
              visible: _vm.applyFormVisible,
              type: _vm.applyFormType,
              id: _vm.selectedId,
              projectType: _vm.selectedProjectType,
              projectStatus: _vm.selectedProjectStatus,
              fromTab: _vm.tabActiveName,
              selectedItemId: _vm.selectedItemId,
            },
            on: {
              "update:visible": function ($event) {
                _vm.applyFormVisible = $event
              },
            },
          }),
        ],
        1
      ),
      _c("quotationApprovalDrawer", {
        attrs: {
          visible: _vm.quotationDrawerVisible,
          id: _vm.selectedId,
          projectType: _vm.selectedProjectType,
          title: _vm.drawerTitle,
        },
        on: {
          "update:visible": function ($event) {
            _vm.quotationDrawerVisible = $event
          },
          close: _vm.handleClose,
        },
      }),
      _c("FollowUpDialog", {
        attrs: {
          visible: _vm.followUpVisible,
          projectId: _vm.followUpProjectId,
          taskId: _vm.followUpTaskId,
        },
        on: {
          "update:visible": function ($event) {
            _vm.followUpVisible = $event
          },
          success: _vm.handleFollowUpSuccess,
        },
      }),
      _c("ticketFollowUpDialog", {
        ref: "ticketFollowUpDialog",
        attrs: { visible: _vm.ticketFollowUpVisible },
        on: {
          "update:visible": function ($event) {
            _vm.ticketFollowUpVisible = $event
          },
          success: _vm.handleTicketActionSuccess,
        },
      }),
      _c("ticketAssignDialog", {
        ref: "ticketAssignDialog",
        attrs: {
          visible: _vm.ticketAssignVisible,
          title: "分配工单",
          "success-message": "分配成功",
        },
        on: {
          "update:visible": function ($event) {
            _vm.ticketAssignVisible = $event
          },
          success: _vm.handleTicketActionSuccess,
        },
      }),
      _c("quotationAssignDialog", {
        ref: "quotationAssignDialog",
        attrs: { visible: _vm.quotationAssignVisible },
        on: {
          "update:visible": function ($event) {
            _vm.quotationAssignVisible = $event
          },
          success: _vm.refreshQuotationListAndCount,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }